import { BillingApi, Configuration } from '@/api';
import { getBillingInfoQueryKey } from '@/api/queries/useGetBillingInfoQuery';
import { SubscriptionUpdate } from '@/models/Billing';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useUpdateSubscriptionMutation() {
  const queryClient = useQueryClient();
  const auth = useAuth();
  const api = new BillingApi(new Configuration(auth));

  return useMutation({
    mutationFn: async (subscription: SubscriptionUpdate) => {
      return api.updateSubscription(subscription);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: getBillingInfoQueryKey });
    },
  });
}
